import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataProtectionNotice, DataProtectionNoticeItem } from '../models/data-protection-notice.model';
import { DataProtectionNoticeEndpoint } from '../constants/data-protection-notice-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ProfileEndpoint } from '../../profile/constants/profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeItemService {
  constructor(private http: WrapperHttpService) {}

  getDpnItem(dpnItemId: number): Observable<DataProtectionNoticeItem> {
    return this.http
      .withLoading()
      .get<DataProtectionNoticeItem>(
        `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Version}/${dpnItemId}`,
      );
  }

  saveDpnItem(body: Partial<DataProtectionNoticeItem>): Observable<void> {
    return this.http.withLoading().post<void>(`${API_URL}${DataProtectionNoticeEndpoint.Base}`, body);
  }

  updateDpnItem(body: DataProtectionNotice): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(`${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Version}`, body);
  }

  publishDpnItem(dpnItemId: number): Observable<void> {
    return this.http
      .withLoading()
      .patch<void>(
        `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Version}/${dpnItemId}${DataProtectionNoticeEndpoint.Publish}`,
        {},
      );
  }

  deleteDpnItem(dpnItemId: number): Observable<void> {
    return this.http
      .withLoading()
      .delete<void>(
        `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Version}/${dpnItemId}`,
        {},
      );
  }

  deleteDpnList(dpnListId: number): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${DataProtectionNoticeEndpoint.Base}/${dpnListId}`, {});
  }

  acceptDpnItem(): Observable<string> {
    return this.http
      .withLoading()
      .post<string>(
        `${API_URL}${ProfileEndpoint.Base}${DataProtectionNoticeEndpoint.Accept}`,
        {},
        { responseType: 'text' },
      );
  }
}
